/*eslint react/no-string-refs: "off" */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import $ from 'jquery';
import Document, * as DocumentExport from 'store/entity/Document';
import PublicProperties from 'store/entity/PublicProperties';
import Address from 'store/entity/Address';
import message from './message';
import GeneralInformation from '../Panels/GeneralInfomation/GeneralInformation';
import ProfilePicture from '../Panels/ProfilePicture/ProfilePicture';
import SocialNetworks from '../Panels/SocialNetworks/SocialNetwork';
import * as ErrorDialog from 'components/ErrorView/ErrorDialog';
import LoadingIndicator from 'components/LoadingIndicator';
import MainNavbar from 'components/MainNavbar';
import protectedRoute from 'components/protectedRoute';
import Button from 'components/Button';
import {
  deleteItem,
  item_createNewDocument,
  item_delete,
  registerProvider,
  updateProvider,
} from 'store/providers/providerSlice';
import { Provider } from 'store/providers/providerUtils';
import { checkProviderStatus } from '../../../store/thisUser/thisUserSlice';

class WizardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.pageTitle =
      this.props.thisUser?.provider.provider_register === 'Registered'
        ? message.editProfile
        : message.createProfile;
    this.state = {
      stage: 1,
      loadingProvider: true,
    };
    this.pictures = {
      profilePicture: undefined,
      background: undefined,
    };
    this.generalInformation = null;
    this.socialNetwork = null;
  }

  componentDidMount() {
    this.componentDidUpdate();

    this.props
      .dispatch(checkProviderStatus({}))
      .then(() => {
        this.setState({ loadingProvider: false });
      })
      .catch((err) => {
        ErrorDialog.display(err);
      });
  }

  componentDidUpdate() {
    $(this.refs.footerTabs).tabs();
    if (this.refs.tabs !== undefined) {
      $(this.refs.tabs).tabs({});
    }
  }

  nextStage(srcId, id) {
    return () => {
      if (srcId === 'gi') {
        this.setState({ gi_saving: true });
        this.save().then(
          () => {
            $('ul.tabs').tabs('select_tab', id);
            this.setState({ gi_saving: false });
          },
          (err) => {
            $('ul.tabs').tabs('select_tab', srcId);
            this.setState({ gi_saving: false });
            ErrorDialog.display(err);
          }
        );
      } else if (srcId === 'pp') {
        this.setState({ pp_saving: true });
        this.uploadDocuments().then(
          () => {
            this.setState({ pp_saving: false });
            $('ul.tabs').tabs('select_tab', id);
          },
          () => {
            $('ul.tabs').tabs('select_tab', srcId);
            this.setState({ pp_saving: false });
          }
        );
      } else if (srcId === 'sn') {
        this.save().then(() => {
          navigate('/content');
        });
      }
    };
  }

  handleChangeBackground = (item, data) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.background = { item: jsItem, data };
  };

  handleChangeProfilePicture = (item, data) => {
    let jsItem;
    if (item) {
      jsItem = item;
    }
    this.pictures.profilePicture = { item: jsItem, data };
  };

  uploadDocuments() {
    const provider = this.props.provider.data;
    let profilePromise;
    let backgroundPromise;
    if (!(typeof this.pictures.profilePicture === 'undefined')) {
      if (this.pictures.profilePicture.data === null) {
        this.props.dispatch(
          item_delete({ item: this.pictures.profilePicture.item })
        );
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.profilePicture,
          documentProperties
        );
        const providerDocument = new ProviderDocument(
          provider.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        profilePromise = this.props
          .dispatch(
            item_createNewDocument({
              item: providerDocument,
              file: this.pictures.profilePicture.data,
            })
          )
          .then(
            () => {
              const ans = Promise.resolve();
              if (this.pictures.profilePicture.item !== null) {
                this.props.dispatch(
                  deleteItem({ item: this.pictures.profilePicture.item })
                );
              }
              this.pictures.profilePicture = undefined;
              return ans;
            },
            (err) => {
              ErrorDialog.display(err);
              return Promise.reject(err);
            }
          );
      }
    }
    if (!(typeof this.pictures.background === 'undefined')) {
      if (this.pictures.background.data === null) {
        this.props.dispatch(
          item_delete({ item: this.pictures.background.item })
        );
      } else {
        const documentProperties = { photo: true };
        const document = new Document(
          null,
          DocumentExport.documentType.banner,
          documentProperties
        );
        const providerDocument = new ProviderDocument(
          provider.id,
          undefined,
          null,
          null,
          document,
          true,
          0
        );
        backgroundPromise = this.props
          .dispatch(
            item_createNewDocument({
              item: providerDocument,
              file: this.pictures.background.data,
            })
          )
          .then(
            () => {
              const ans = Promise.resolve();
              if (this.pictures.background.item !== null) {
                this.props.dispatch(
                  deleteItem({ item: this.pictures.background.item })
                );
              }
              this.pictures.background = undefined;
              return ans;
            },
            (err) => {
              ErrorDialog.display(err);
              return Promise.reject(err);
            }
          );
      }
    }
    return Promise.all([profilePromise, backgroundPromise]);
  }

  save() {
    const giValues = this.generalInformation;
    const snRef = this.socialNetwork.refs;
    let provider;
    let isRegistered = false;
    if (this.props.thisUser?.provider.isLoading) {
      return;
    }
    if (!provider) provider = new Provider();
    provider.name = giValues.name;
    provider.address = new Address(
      giValues.address,
      giValues.location.lat,
      giValues.location.lng,
      giValues.postalCode,
      giValues.phoneNumber
    );
    provider.user = this.props.thisUser?.userId;
    provider.description = giValues.description;
    provider.publicProperties = new PublicProperties(
      giValues.description,
      snRef.telegramChanel.value,
      snRef.telegramId.value,
      snRef.instagramId.value,
      snRef.facebook.value,
      null,
      snRef.linkedIn.value,
      snRef.aparat.value,
      snRef.website.value,
      snRef.email.value,
      null,
      giValues.workingContext
    );
    if (isRegistered) {
      return this.props
        .dispatch(updateProvider({ provider }))
        .then(this.uploadDocuments.bind(this), (err) => {
          ErrorDialog.display(err);
        });
    }
    return this.props
      .dispatch(registerProvider({ provider }))
      .then(navigate('/homepage'));
  }

  render() {
    const { provider } = this.props;
    const registered = undefined;
    if (this.state.loadingProvider) {
      return <LoadingIndicator />;
    }
    return (
      <div>
        <header style={{ padding: 0 }}>
          <MainNavbar title={{ view: this.title }} />
        </header>
        <main style={{ padding: 0 }}>
          <div className="custom-container">
            <div className="row">
              <div className="col s12 " style={{ overflowX: 'auto' }}>
                <ul
                  className="tabs tabs-fixed-width"
                  ref="tabs"
                  style={{ minWidth: '500px', marginBottom: '2rem' }}
                >
                  <li className={'tab '}>
                    <a href="#gi">{message.generalInformation}</a>
                  </li>
                  <li className={`tab ${registered ? '' : 'disabled'}`}>
                    <a href="#pp">{message.profilePicture}</a>
                  </li>
                  <li className={`tab ${registered ? '' : 'disabled'}`}>
                    <a href="#sn">{message.socialConnections}</a>
                  </li>
                </ul>
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
                id="gi"
                className="col s12"
              >
                <GeneralInformation
                  ref={(input) => {
                    this.generalInformation = input;
                  }}
                  onSave={this.nextStage('gi', 'pp')}
                  saving={this.state.gi_saving}
                  provider={provider}
                  className="section"
                />
              </div>
              {registered && (
                <div
                  style={{ display: 'flex', flexDirection: 'column' }}
                  id="pp"
                  className="col s12"
                >
                  <ProfilePicture
                    ref={(input) => {
                      this.profilePicture = input;
                    }}
                    provider={provider}
                    changeBackground={this.handleChangeBackground}
                    changeProfilePicture={this.handleChangeProfilePicture}
                    className="section"
                  />
                  {!this.state.pp_saving ? (
                    <Button
                      style={{ display: 'flex', margin: '2rem 0.7rem' }}
                      color="green"
                      onClick={this.nextStage('pp', 'sn')}
                    >
                      {message.next}
                    </Button>
                  ) : (
                    <div className="progress">
                      <div className="indeterminate" />
                    </div>
                  )}
                </div>
              )}
              {
                <div
                  style={{ display: 'flex', flexDirection: 'column' }}
                  id="sn"
                  className="col s12"
                >
                  <SocialNetworks
                    ref={(input) => {
                      this.socialNetwork = input;
                    }}
                    provider={provider}
                    className="section"
                  />
                  <Button
                    style={{ display: 'flex', margin: '2rem 0.7rem' }}
                    color="green"
                    onClick={this.nextStage('sn', 'doc')}
                  >
                    {message.saveAndFinish}
                  </Button>
                </div>
              }
            </div>
          </div>
        </main>
      </div>
    );
  }
}

WizardContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  thisUser: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const thisUser = state.data?.thisUser;
  const provider = {
    data: {
      id: null,
      categories: null,
      address: null,
      user: null,
      name: null,
      status: { register: 'NotRegistered', active: 'Disable' },
      documents: null,
      publicProperties: null,
      tags: null,
      description: null,
      bookmark: null,
      rootDocument: null,
      template: null,
      infoSurveyResponse: null,
      survey: null,
      managingCompanyId: null,
      limitAccessToCompany: null,
    },
  };
  return { provider, thisUser };
};

export default protectedRoute(connect(mapStateToProps)(WizardContainer));
